import * as duplicationsApi from './requests';
import { 
    GET_APPLICANT_DUPLICATION_INFO,
    DUPLICATION_LOADING,
    DUPLICATION_ERROR
} from 'actions/types';

// Get comprehensive duplication information for a specific applicant
// This endpoint returns both ex-employee and duplicate information
export const getApplicantDuplicationInfo = (applicantId) => async (dispatch) => {
    try {
        dispatch({ type: DUPLICATION_LOADING, payload: true });
        const response = await duplicationsApi.getApplicantDuplicationInfo(applicantId);
        dispatch({ 
            type: GET_APPLICANT_DUPLICATION_INFO, 
            payload: response.data 
        });
        return response.data;
    } catch (error) {
        dispatch({ 
            type: DUPLICATION_ERROR, 
            payload: error.response?.data?.message || 'Failed to get duplication information' 
        });
        throw error;
    } finally {
        dispatch({ type: DUPLICATION_LOADING, payload: false });
    }
};